import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Home from "./pages/Home";
import TerminiCondizioni from "./pages/TerminiCondizioni";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import CookiePolicy from "./pages/CookiePolicy";
import Reclami from "./pages/Reclami";
import Precontrattuale from "./pages/Precontrattuale";
import SocietaBenefit from "./pages/SocietaBenefit";
import SocietaCooperativa from "./pages/SocietaCooperativa";
import Mission from "./pages/Mission";
import Quotazione from "./pages/Quotazione";
import BastaLaTarga from "./pages/BastaLaTarga";
import TrasparenzaReclami from "./pages/TrasparenzaReclami";
import Tirocini from "./pages/Tirocini";
import AdminAvvisi from "./pages/AdminAvvisi";
import TrasparenzaIA from "./pages/TrasparenzaIA";
import ReteAccordi from "./pages/ReteAccordi";
import AccordoDettaglio from "./pages/AccordoDettaglio";
import CookieBanner from "./components/CookieBanner";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/termini-condizioni" element={<TerminiCondizioni />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/cookie-policy" element={<CookiePolicy />} />
          <Route path="/reclami" element={<Reclami />} />
          <Route path="/precontrattuale" element={<Precontrattuale />} />
          <Route path="/societa-benefit" element={<SocietaBenefit />} />
          <Route path="/societa-cooperativa" element={<SocietaCooperativa />} />
          <Route path="/mission" element={<Mission />} />
          <Route path="/quotazione" element={<Quotazione />} />
          <Route path="/basta-la-targa" element={<BastaLaTarga />} />
          <Route path="/trasparenza-reclami" element={<TrasparenzaReclami />} />
          <Route path="/tirocini" element={<Tirocini />} />
          <Route path="/admin/avvisi" element={<AdminAvvisi />} />
          <Route path="/trasparenza-ia" element={<TrasparenzaIA />} />
          <Route path="/rete-di-accordi" element={<ReteAccordi />} />
          <Route path="/rete-di-accordi/:slug" element={<AccordoDettaglio />} />
        </Routes>
        <CookieBanner />
      </BrowserRouter>
    </div>
  );
}

export default App;
